export const convertMinToHour = (min) => {
    if (min < 60) return `${min} min`;

    const hours = Math.floor(min / 60);
    const minutes = min % 60;

    return minutes === 0 ? `${hours} hr` : `${hours} hr ${minutes} min`;
};